import React, { Component } from 'react'
import { PanelGroup, Panel } from 'react-bootstrap'

class SiteGroundFAQs extends Component{
	constructor(props){
		super(props)
		this.state = {}
		this.handleFAQSelect = this.handleFAQSelect.bind(this)
	}
	
	handleFAQSelect(activeFAQKey) {
		let _key = this.state.activeFAQKey
		if (_key && _key == activeFAQKey) {
			this.setState({ activeFAQKey: false })
		} else {
			this.setState({ activeFAQKey: activeFAQKey })
		}
	}
	
	render(){
		const { activeFAQKey } = this.state
		return (
			<div>
				<PanelGroup 
					activeKey={activeFAQKey} 
					onSelect={this.handleFAQSelect} 
					id="siteground"
					bsClass="col-xs-10 col-md-10 bv-faq-accordion-list" 
					accordion
				>
					<Panel eventKey="1">
						<Panel.Heading bsClass="panel-heading">
							<Panel.Title toggle>
								<p className="bv-faq-que">
									{ this.state.activeFAQKey == "1" ? <i className="mdi mdi-minus"></i> : <i className="mdi mdi-plus"></i> }
									What is Destination Site URL?
								</p>
							</Panel.Title>
						</Panel.Heading>
						<Panel.Body collapsible>
							<p className="bv-faq-ans">
								Destination Site URL of the site you are moving to.
							</p>
						</Panel.Body>
					</Panel>

					<Panel eventKey="2">
						<Panel.Heading bsClass="panel-heading">
							<Panel.Title toggle>
								<p className="bv-faq-que">
									{ this.state.activeFAQKey == "2" ? <i className="mdi mdi-minus"></i> : <i className="mdi mdi-plus"></i> }
									Where can I find my cPanel Credentials?
								</p>
							</Panel.Title>
						</Panel.Heading>
						<Panel.Body collapsible>
							<p className="bv-faq-ans">
								Log into your SiteGround account. Click on <strong>My Accounts</strong>. Go to <strong>Information and Settings</strong>.
								<strong>Domain Name</strong> is your Destination URL
								<strong>Account IP</strong>  is your server IP address
								Enter your <strong>cPanel Username</strong> in the field.
								Your <strong>cPanel Password</strong> would have been mailed to you.
								If you do not remember the password then there is a button to the right of your cPanel username to reset your cPanel password.
							</p>
						</Panel.Body>
					</Panel>

				</PanelGroup>
			</div>
		)	
	}
}

export default SiteGroundFAQs
